
export default {
  data () {
    return {
      options: {}
    }
  },
  mounted() {
    this.$root.$on('showErrorSnackbar', this.onShowSnackbar)
  },
  beforeDestroy() {
    this.$root.$off('showErrorSnackbar', this.onShowSnackbar)
  },
  methods: {
    onShowSnackbar(opt) {
      let isMulti = Array.isArray(opt) && opt?.length > 1
      const options = (Array.isArray(opt)  ? opt : [opt] ) || []

      let messages = ''

      options.forEach((option) => {
        let message
        if (option?.extensions?.code && this.$t(`Errors.${option.extensions.code}`) !== `Errors.${option.extensions.code}`) {
          message = this.$t(`Errors.${option.extensions.code}`)
        } else  if (option?.message) {
          message = this.slice(option.message)
        } else {
          message = this.slice(option ?? '')
        }
        let regex = /GraphQL.ExecutionError: /ig
        message = message.replaceAll(regex, '')

        regex = /GraphQL error: /ig
        message = message.replaceAll(regex, '')
        if (message !== 'GraphQL.ExecutionError') {
          message = isMulti ? `● ${message}` : message
          messages = messages?.length ? `${messages}</br></br>${message}` : message
        }
      })

      if (messages?.length) {
        this.$notice.error({
          title: this.$t('Common.ErrorTitle'),
          dangerouslyUseHTMLString: true,
          message: messages,
          showClose: true,
          duration: 5
        })
      }
    },
    slice(text) {
      if (text?.length > 400) {
        return text.slice(0, 400) + '...'
      } else {
        return text
      }
    }
  },
  watch: {
    '$route'() {
      this.show = false
    }
  }
}
